import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { modificarInicioDeLlenado } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionModificarInicioDeLlenadoView } from '../components/OperacionModificarInicioDeLlenadoView'

export const OperacionModificarInicioDeLlenado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionModificarInicioDeLlenadoView
        silo={silo}
        aceptar={async ({ cereal, variedad, etiqueta, color }) => {
          try {
            await modificarInicioDeLlenado(silo, cereal, variedad, etiqueta, color)
            closeDialog()
            enqueueSnackbar('Modificacion de inicio de llenado correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Modificacion de inicio de llenado incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('MODIFICACION_INICIO_DE_LLENADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
